import React from 'react';
import styles from '../index.module.scss';
import AssignPatientBlock from './AssignPatientBlock';
import POAField from './POAField';
import useIntakeBlockToggle, {
  intakeBlocksEnum,
} from '../../../../hooks/useIntakeBlockToggle';
import { intakeSectionConfig } from '../../../../hooks/types';
import useIntakeData from '../../../../../../../../services/intakeDataService/index';

const GeneralSettings = () => {
  const { isOn } = useIntakeBlockToggle();
  const { data } = useIntakeData();

  if (
    !intakeSectionConfig.generalSettings?.some((config) => {
      if (config === intakeBlocksEnum.assignpt) {
        return isOn(config) && data?.isAllowedToTreat;
      }
      return isOn(config);
    })
  ) {
    return null;
  }

  return (
    <div className={styles.sectionWrapper}>
      <span className={styles.sectionTitle}>General Settings</span>
      <div className={styles.filedsWrapper}>
        <AssignPatientBlock />
        <POAField />
      </div>
    </div>
  );
};

export default GeneralSettings;
